import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import Layout from 'Views/Page/Content/Templates/MeetingInfoOutroStep/Layout';
import React from 'react';
import { FDBodyText, FDHeadlineText, FDTitleText } from '@facet-wealth/design';


const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('nextMeetingAgendaTitle', {
    _component: () => FDHeadlineText,
  }, overrideReadOnly)
  .nameOverride('nextMeetingTitle', {
    _component: () => FDBodyText,
    _customProps: {
      size: 'lg',
    },
  }, overrideReadOnly)
  .nameOverride('leadPlannerName', {
    _component: () => FDTitleText,
    _customProps: {
      size: 'lg',
    },
  }, overrideReadOnly);

const MeetingInfoOutroStepTemplate = ({ resource }) => {
  return (
    <MetaResourceRenderer
      layout={Layout}
      resource={resource}
      metaOverrideSet={metaOverrideSet}
    />
  );
};

export default MeetingInfoOutroStepTemplate;
